import { Fragment, useState } from 'react';
import styled from 'styled-components';
import { BUTTON_SIZES, BUTTON_VARIANTS } from 'ui/button';
import {
  ARROW_DIRECTION_DOWN,
  CollapsibleContent,
  CollapsibleContentArrow,
} from 'ui/collapsibleContent';
import { LinkedName, Name } from './Styled';
import {
  ArrowButton,
  CollapsibleItem,
  CollapsibleNameCell,
  Content,
  PrimaryCaption,
  SecondaryCaption,
} from '../../campaignIndex/components/CampaignNameCell.styles';
import { GraphQLSnippet } from '../types';

type Props = {
  snippet: GraphQLSnippet;
  canManageSnippets: boolean;
};

const StyledCollapsibleContent = styled(CollapsibleContent)`
  grid-column: 3 / span 1;
  grid-row: 2 / span 1;
  grid-column-start: 1;
`;

export const SnippetNameCell = ({ snippet, canManageSnippets }: Props) => {
  const [isCollapsed, setIsCollapsed] = useState(true);

  return (
    <Fragment key={snippet.id}>
      <CollapsibleNameCell data-test={`snippet-${snippet.id}-name-cell`}>
        <Content data-test="snippet-content">
          {canManageSnippets ? (
            <LinkedName
              to={`/templates/snippet/${snippet.id}/edit`}
              data-test={`snippet-name-link-${snippet.id}`}
            >
              {snippet.name}
            </LinkedName>
          ) : (
            <Name data-test={`snippet-name-${snippet.id}`}>{snippet.name}</Name>
          )}
        </Content>

        <ArrowButton
          onClick={() => setIsCollapsed(!isCollapsed)}
          data-test="collapsible-arrow-button"
          size={BUTTON_SIZES.SMALL}
          variant={BUTTON_VARIANTS.GHOST}
        >
          <CollapsibleContentArrow
            isCollapsed={isCollapsed}
            arrowStart={ARROW_DIRECTION_DOWN}
            arrowEnd={180}
            width={16}
            height={16}
          />
        </ArrowButton>
      </CollapsibleNameCell>

      <StyledCollapsibleContent
        isCollapsed={isCollapsed}
        data-test={`collapsible-snippet-name${isCollapsed ? '-collapsed' : ''}`}
      >
        {snippet.name && (
          <CollapsibleItem data-test="snippet-detail">
            <SecondaryCaption data-test="snippet-detail-key">Snippet ID:</SecondaryCaption>
            <PrimaryCaption data-test="snippet-detail-value">{snippet.id}</PrimaryCaption>
          </CollapsibleItem>
        )}

        {snippet.description && (
          <CollapsibleItem>
            <SecondaryCaption data-test="snippet-detail-key">Description:</SecondaryCaption>
            <PrimaryCaption data-test="snippet-detail-value">{snippet.description}</PrimaryCaption>
          </CollapsibleItem>
        )}
      </StyledCollapsibleContent>
    </Fragment>
  );
};
